export const getHumanReadableFileSize = (size, onlyPositives = true, modifier = 1024) => {
  if (size === undefined) {
    return '0,00';
  }

  let index = -1;
  do {
    size /= modifier;
    index++;
  } while (size > modifier);

  if (onlyPositives) {
    size = Math.max(size, 0.1);
  }

  return size.toFixed(2) + [' kB', ' MB', ' GB'][index];
};

export const isOcrable = ({ type }) => {
  return [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
  ].includes(type);
};

